import {ApogeeFile} from "./apogee-file";
import {BaseObject} from "./base-object";

export const franchiseTiers = [
  'TIER1', // Champions League
  'TIER2', // Europa League
  'TIER3', // Conference League
] as const;

export type FranchiseTier = typeof franchiseTiers[number];

export class WebsiteSettings extends BaseObject {

  public logo: ApogeeFile;
  public requireAgbAcceptanceOnRegistration: boolean;
  public usesAcademyApp: boolean;
  public franchiseTier: FranchiseTier;
  public franchiseTierNotes: string;

  constructor(el: any = {}) {
    super(el);

    if (!el) {
      el = {};
    }

    this.logo = new ApogeeFile(el.logo);
    this.requireAgbAcceptanceOnRegistration = el.requireAgbAcceptanceOnRegistration ?? false;
    this.usesAcademyApp = el.usesAcademyApp ?? false;
    this.franchiseTier = el.franchiseTier;
    this.franchiseTierNotes = el.franchiseTierNotes ?? "";
  }

  public override toJson(): any {
    return {
      ...super.toJson(),
      logo: this.logo,
      requireAgbAcceptanceOnRegistration: this.requireAgbAcceptanceOnRegistration,
      usesAcademyApp: this.usesAcademyApp,
      franchiseTier: this.franchiseTier,
      franchiseTierNotes: this.franchiseTierNotes,
    };
  }
}
